import React from 'react';

interface StarRatingProps {
  rating: number;
  maxStars?: number;
  size?: 'xs' | 'sm' | 'md' | 'lg';
  showEmptyStars?: boolean;
  className?: string;
  goldColor?: string;
  grayColor?: string;
}

export const StarRating: React.FC<StarRatingProps> = ({
  rating,
  maxStars = 5,
  size = 'md',
  showEmptyStars = true,
  className = '',
  goldColor = '#C8A951',
  grayColor = '#D1D5DB'
}) => {
  const sizeMap = {
    xs: 12,
    sm: 16,
    md: 18,
    lg: 24
  };

  const starSize = sizeMap[size];

  const renderStar = (index: number) => {
    const starValue = index + 1;
    const fillPercentage = Math.min(Math.max((rating - index), 0), 1) * 100;

    // Determine fill color based on percentage
    const isFilled = fillPercentage > 0;
    const isEmpty = fillPercentage === 0;
    const isHalf = fillPercentage > 0 && fillPercentage < 100;

    const starId = `star-gradient-${index}-${Math.random().toString(36).substr(2, 9)}`;

    return (
      <svg
        key={index}
        width={starSize}
        height={starSize}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="inline-block"
        style={{ marginRight: index < maxStars - 1 ? '2px' : '0' }}
      >
        {isHalf && (
          <defs>
            <linearGradient id={starId} x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset={`${fillPercentage}%`} stopColor={goldColor} />
              <stop offset={`${fillPercentage}%`} stopColor={grayColor} />
            </linearGradient>
          </defs>
        )}
        <path
          d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"
          fill={
            isHalf
              ? `url(#${starId})`
              : isFilled
              ? goldColor
              : grayColor
          }
          stroke="none"
        />
      </svg>
    );
  };

  const starsToRender = showEmptyStars ? maxStars : Math.ceil(rating);

  return (
    <div className={`inline-flex items-center ${className}`}>
      {Array.from({ length: starsToRender }, (_, i) => renderStar(i))}
    </div>
  );
};
